import React from "react";

/**
 * Empty module body state.
 * @param {object} props
 * @param {string} props.message
 * @param {string|null} [props.ctaLabel]
 * @param {() => void} [props.onCtaClick]
 * @param {string} [props.testId]
 */
export function EmptyState({ message, ctaLabel, onCtaClick, testId = "empty-state" }) {
  return (
    <div className="cq-empty-state" data-testid={testId}>
      <p>{message}</p>
      {ctaLabel ? (
        <button type="button" className="cq-empty-state__cta" onClick={onCtaClick}>
          {ctaLabel}
        </button>
      ) : null}
    </div>
  );
}
